var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inquiry)?_c('detail',{key:_vm.inquiry.id,ref:"d",attrs:{"inquiry":_vm.inquiry},on:{"reload":function($event){return _vm.$emit('reload')}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }